import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PricingPlans } from "../components/PricingPlans";

const CSS = `
.agz-landing{
  --paper:#FAF8F3; --paper-2:#F3EFE7; --card:#FFFFFF;
  --ink:#181621; --ink-soft:#54505B; --muted:#9A9591;
  --line:#EAE5DB; --line-soft:#F1EDE4;
  --coral:#E0603A; --coral-d:#C24E2C; --peach:#F5D6C6; --peach-2:#F0C3AC;
  --blue:#0B67FF; --blue-d:#0A55D6; --blue-soft:#E4EEFF; --gold:#E0A63C;
  --r-card:20px; --r-md:14px; --r-btn:12px; --r-sm:9px;
  --sh-xs:0 1px 2px rgba(24,22,33,.05);
  --sh-sm:0 2px 6px rgba(24,22,33,.06), 0 10px 24px -12px rgba(24,22,33,.14);
  --sh-card:0 4px 10px rgba(24,22,33,.05), 0 30px 60px -24px rgba(24,22,33,.22);
  --sh-float:0 18px 44px -18px rgba(24,22,33,.30);
  --max:1160px; --pad:clamp(20px,5vw,60px);
  --sans:"Geist",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;
}
.agz-landing{font-family:var(--sans);color:var(--ink);background:var(--paper);line-height:1.5;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;overflow-x:clip}
.agz-landing :where(*:not(#pricing-embed, #pricing-embed *)){box-sizing:border-box;margin:0;padding:0}
.agz-landing{box-sizing:border-box;margin:0;padding:0}
.agz-landing section[id],.agz-landing .sec[id]{scroll-margin-top:78px}
.agz-landing a{color:inherit;text-decoration:none}
.agz-landing img{max-width:100%;display:block}
.agz-landing ::selection{background:var(--blue);color:#fff}
.agz-landing .wrap{max-width:var(--max);margin:0 auto;padding:0 var(--pad)}
.agz-landing h1,.agz-landing h2,.agz-landing h3,.agz-landing h4{font-weight:600;letter-spacing:-.03em;line-height:1.05}
.agz-landing .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:var(--sans);font-weight:600;font-size:14.5px;padding:12px 20px;border-radius:var(--r-btn);border:1px solid transparent;cursor:pointer;transition:transform .18s ease,box-shadow .2s ease,background .2s,border-color .2s;white-space:nowrap}
.agz-landing .btn svg{width:15px;height:15px}
.agz-landing .btn--primary{background:var(--ink);color:#fff}
.agz-landing .btn--primary:hover{transform:translateY(-1px);box-shadow:var(--sh-sm)}
.agz-landing .btn--ghost{background:var(--card);color:var(--ink);border-color:var(--line)}
.agz-landing .btn--ghost:hover{border-color:#cfc9bd;transform:translateY(-1px)}
.agz-landing .btn--blue{background:var(--blue);color:#fff}
.agz-landing .btn--blue:hover{background:var(--blue-d);transform:translateY(-1px)}
.agz-landing .btn--lg{padding:14px 24px;font-size:15.5px}
.agz-landing .newbadge{display:inline-flex;align-items:center;gap:9px;background:var(--card);border:1px solid var(--line);border-radius:999px;padding:5px 14px 5px 6px;font-size:13px;color:var(--ink-soft);box-shadow:var(--sh-xs);transition:transform .18s,box-shadow .2s}
.agz-landing .newbadge:hover{transform:translateY(-1px);box-shadow:var(--sh-sm)}
.agz-landing .newbadge .n{background:var(--ink);color:#fff;font-weight:600;font-size:11.5px;padding:3px 9px;border-radius:999px}
.agz-landing .newbadge .chev{color:var(--muted);font-weight:600}
.agz-landing .nav{position:sticky;top:0;z-index:70;background:rgba(250,248,243,.8);backdrop-filter:saturate(150%) blur(14px);border-bottom:1px solid transparent;transition:border-color .3s}
.agz-landing .nav.stuck{border-color:var(--line)}
.agz-landing .nav .wrap{display:flex;align-items:center;justify-content:space-between;height:68px}
.agz-landing .brand{display:inline-flex;align-items:center}
.agz-landing .brand img{height:26px;width:auto;display:block;vertical-align:middle;object-fit:contain}
.agz-landing .fb .brand img{height:22px}
.agz-landing #proof,.agz-landing #faq{position:relative}
.agz-landing #proof::before{content:"";position:absolute;inset:-6% -4%;background:radial-gradient(55% 50% at 50% 45%,rgba(240,195,172,.20),transparent 70%);filter:blur(48px);pointer-events:none;z-index:0}
.agz-landing #faq::before{content:"";position:absolute;inset:-6% -4%;background:radial-gradient(50% 48% at 50% 40%,rgba(11,103,255,.07),transparent 70%);filter:blur(48px);pointer-events:none;z-index:0}
.agz-landing #proof .wrap,.agz-landing #faq .wrap{position:relative;z-index:1}
.agz-landing .nav-mid{display:flex;gap:32px}
.agz-landing .nav-mid a{font-size:14.5px;color:var(--ink-soft);font-weight:500;transition:color .2s}
.agz-landing .nav-mid a:hover{color:var(--ink)}
.agz-landing .nav-right{display:flex;align-items:center;gap:12px}
.agz-landing .nav-right .login{font-size:14.5px;color:var(--ink-soft);font-weight:600;padding:8px 4px}
.agz-landing .nav-right .login:hover{color:var(--ink)}
.agz-landing .nav-burger{display:none;width:40px;height:40px;align-items:center;justify-content:center;background:transparent;border:1px solid var(--line);border-radius:10px;cursor:pointer;padding:0;transition:border-color .2s,background .2s}
.agz-landing .nav-burger:hover{border-color:#cfc9bd}
.agz-landing .nav-burger svg{width:20px;height:20px;stroke:var(--ink);fill:none;stroke-width:2;stroke-linecap:round}
.agz-landing .nav-mobile{display:none;position:absolute;top:68px;left:0;right:0;background:var(--paper);border-bottom:1px solid var(--line);box-shadow:var(--sh-sm);padding:12px var(--pad) 20px;flex-direction:column;gap:2px;animation:agzFadeUp .22s ease both}
.agz-landing .nav-mobile.open{display:flex}
.agz-landing .nav-mobile a{font-size:16px;color:var(--ink);font-weight:500;padding:14px 4px;border-bottom:1px solid var(--line-soft)}
.agz-landing .nav-mobile a:last-of-type{border-bottom:0}
.agz-landing .nav-mobile .login-m{font-size:15px;color:var(--ink-soft);font-weight:600;padding:14px 4px;border-bottom:1px solid var(--line-soft)}
@media(max-width:880px){.agz-landing .nav-mid{display:none}.agz-landing .nav-right .login{display:none}.agz-landing .nav-burger{display:inline-flex}}
@media(min-width:881px){.agz-landing .nav-mobile{display:none !important}}
.agz-landing .hero{position:relative;text-align:center;padding:clamp(52px,8vw,104px) 0 clamp(60px,9vw,120px);overflow:hidden}
.agz-landing .hero-bg{position:absolute;inset:-10% -10% 0;z-index:0;pointer-events:none;filter:blur(56px);opacity:.9}
.agz-landing .hero-bg::before,.agz-landing .hero-bg::after{content:"";position:absolute;border-radius:50%}
.agz-landing .hero-bg::before{width:60%;height:70%;left:6%;top:2%;background:radial-gradient(circle at 40% 40%,rgba(245,150,110,.55),transparent 62%)}
.agz-landing .hero-bg::after{width:62%;height:72%;right:4%;top:0;background:radial-gradient(circle at 60% 40%,rgba(11,103,255,.34),transparent 60%)}
.agz-landing .hero-bg span{position:absolute;width:44%;height:56%;left:28%;top:24%;background:radial-gradient(circle,rgba(196,120,220,.24),transparent 65%);border-radius:50%}
.agz-landing .hero .wrap{position:relative;z-index:3}
.agz-landing .hero h1{font-size:clamp(40px,6.4vw,78px);letter-spacing:-.04em;max-width:15ch;margin:22px auto 0}
.agz-landing .hero .sub{font-size:clamp(16.5px,1.9vw,20px);color:var(--ink-soft);max-width:52ch;margin:22px auto 0;line-height:1.55}
.agz-landing .hero .cta{display:flex;gap:12px;justify-content:center;margin-top:32px;flex-wrap:wrap}
.agz-landing .hero .note{margin-top:22px;font-size:13.5px;color:var(--muted)}
.agz-landing .floats{position:absolute;inset:0;z-index:2;pointer-events:none}
.agz-landing .fcard{position:absolute;background:var(--card);border:1px solid var(--line);border-radius:var(--r-md);box-shadow:var(--sh-float);padding:15px;pointer-events:auto;will-change:transform}
.agz-landing .fcard .ft{font-size:11.5px;color:var(--muted);font-weight:500;margin-bottom:10px}
.agz-landing .fc-plan{left:2%;top:30%;width:236px}
.agz-landing .fc-metric{right:2.5%;top:22%;width:190px}
.agz-landing .fc-ask{right:5%;bottom:7%;width:280px}
.agz-landing .fc-brain{left:5%;bottom:12%;width:210px}
@media(max-width:1180px){.agz-landing .fc-plan{left:-1%}.agz-landing .fc-metric{right:-1%}}
@media(max-width:1000px){.agz-landing .fc-brain,.agz-landing .fc-ask{display:none}}
@media(max-width:820px){.agz-landing .floats{display:none}}
.agz-landing .donut{display:flex;align-items:center;gap:14px}
.agz-landing .donut .ring{width:64px;height:64px;border-radius:50%;flex:none;background:conic-gradient(var(--coral) 0 40%,var(--blue) 40% 62%,var(--gold) 62% 78%,var(--peach-2) 78% 100%);-webkit-mask:radial-gradient(circle 20px at center,transparent 98%,#000 100%);mask:radial-gradient(circle 20px at center,transparent 98%,#000 100%);position:relative}
.agz-landing .donut .c{font-size:12px}
.agz-landing .donut .c b{font-size:17px;font-weight:700;letter-spacing:-.02em;display:block}
.agz-landing .donut .c span{color:var(--muted)}
.agz-landing .leg{margin-top:12px;display:flex;flex-direction:column;gap:6px}
.agz-landing .leg .lr{display:flex;align-items:center;gap:7px;font-size:11.5px;color:var(--ink-soft)}
.agz-landing .leg .lr i{width:8px;height:8px;border-radius:3px;flex:none}
.agz-landing .leg .lr b{margin-left:auto;font-weight:600;color:var(--ink)}
.agz-landing .metric b.big{font-size:30px;font-weight:700;letter-spacing:-.03em;display:block}
.agz-landing .metric .up{color:#2E8B57;font-size:12.5px;font-weight:600}
.agz-landing .spark{margin-top:8px;height:34px;width:100%}
.agz-landing .ask{display:flex;align-items:center;gap:9px;background:var(--paper);border:1px solid var(--line);border-radius:11px;padding:9px 9px 9px 13px}
.agz-landing .ask input{border:0;background:transparent;font-family:var(--sans);font-size:13px;color:var(--ink);flex:1;outline:none}
.agz-landing .ask input::placeholder{color:var(--muted)}
.agz-landing .ask .send{width:28px;height:28px;border-radius:8px;background:var(--blue);display:flex;align-items:center;justify-content:center;flex:none}
.agz-landing .ask .send svg{width:14px;height:14px;stroke:#fff;fill:none;stroke-width:2.2}
.agz-landing .i3d{width:52px;height:52px;border-radius:15px;position:relative;flex:none;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 14px -4px rgba(24,22,33,.35), inset 0 2px 2px rgba(255,255,255,.55), inset 0 -6px 10px rgba(0,0,0,.14);transform:rotate(-6deg)}
.agz-landing .i3d::after{content:"";position:absolute;inset:0;border-radius:15px;background:radial-gradient(120% 80% at 28% 18%,rgba(255,255,255,.6),transparent 55%)}
.agz-landing .i3d svg{width:24px;height:24px;position:relative;z-index:2;stroke:#fff;fill:none;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
.agz-landing .i3d--coral{background:linear-gradient(155deg,#F1795A,#D24E2A)}
.agz-landing .i3d--blue{background:linear-gradient(155deg,#3D86FF,#0A55D6)}
.agz-landing .i3d--gold{background:linear-gradient(155deg,#F0BD5B,#D18E28)}
.agz-landing .i3d--ink{background:linear-gradient(155deg,#3A3646,#181621)}
.agz-landing .i3d--peach{background:linear-gradient(155deg,#F7D8C9,#EBB196)}
.agz-landing .i3d--peach svg{stroke:#8A4A2E}
.agz-landing .sec{padding:clamp(58px,8vw,108px) 0}
.agz-landing .sec-head{max-width:640px}
.agz-landing .sec-head.center{margin:0 auto;text-align:center}
.agz-landing .sec-head .k{font-size:14px;font-weight:600;color:var(--coral)}
.agz-landing .sec-head h2{font-size:clamp(28px,4.3vw,48px);margin-top:12px;letter-spacing:-.035em}
.agz-landing .sec-head p{color:var(--ink-soft);font-size:clamp(15.5px,1.6vw,18px);margin-top:15px;line-height:1.55}
.agz-landing .sec-head.center p{margin-left:auto;margin-right:auto;max-width:52ch}
.agz-landing .manifesto{text-align:center;padding:clamp(60px,9vw,120px) 0}
.agz-landing .manifesto p{font-size:clamp(28px,4.6vw,54px);font-weight:600;letter-spacing:-.035em;line-height:1.12;margin:0 auto;max-width:18ch}
.agz-landing .manifesto p .b{color:var(--blue)}
.agz-landing .manifesto p .faint{color:var(--ink)}
.agz-landing .manifesto .small{margin-top:22px;color:var(--ink-soft);font-size:16px}
.agz-landing .steps{display:grid;grid-template-columns:repeat(3,1fr);gap:clamp(18px,2.4vw,30px);margin-top:clamp(32px,4vw,56px)}
@media(max-width:800px){.agz-landing .steps{grid-template-columns:1fr;gap:26px}}
.agz-landing .step{background:var(--card);border:1px solid var(--line);border-radius:var(--r-card);padding:28px;transition:transform .25s,box-shadow .25s}
.agz-landing .step:hover{transform:translateY(-4px);box-shadow:var(--sh-card)}
.agz-landing .step .st{font-size:13px;color:var(--muted);font-weight:600;margin:18px 0 6px}
.agz-landing .step h3{font-size:20px;letter-spacing:-.02em}
.agz-landing .step p{color:var(--ink-soft);font-size:14.5px;line-height:1.55;margin-top:9px}
.agz-landing .proof{margin-top:clamp(30px,4vw,48px)}
.agz-landing .ptabs{display:flex;gap:10px;flex-wrap:wrap;justify-content:center;margin-bottom:30px}
.agz-landing .ptab{background:var(--card);border:1px solid var(--line);border-radius:var(--r-btn);padding:10px 16px;cursor:pointer;font-size:14px;font-weight:600;color:var(--ink-soft);transition:all .2s;font-family:var(--sans)}
.agz-landing .ptab:hover{border-color:#cfc9bd}
.agz-landing .ptab.on{background:var(--ink);color:#fff;border-color:var(--ink)}
.agz-landing .pcard{background:var(--card);border:1px solid var(--line);border-radius:var(--r-card);box-shadow:var(--sh-card);overflow:hidden;display:grid;grid-template-columns:1fr 1fr}
@media(max-width:860px){.agz-landing .pcard{grid-template-columns:1fr}}
.agz-landing .pcard .left{padding:clamp(26px,3.4vw,44px)}
.agz-landing .pcard .biz{font-size:clamp(23px,2.6vw,32px);font-weight:600;letter-spacing:-.03em}
.agz-landing .pcard .sub{color:var(--ink-soft);font-size:14.5px;margin-top:8px}
.agz-landing .pcard .quote{margin-top:22px;font-size:clamp(16px,1.8vw,19px);line-height:1.5;color:var(--ink)}
.agz-landing .pcard .opt{margin-top:22px;font-size:13.5px;color:var(--muted)}
.agz-landing .pcard .opt b{color:var(--ink-soft);font-weight:600}
.agz-landing .pcard .right{background:var(--paper-2);border-left:1px solid var(--line);padding:clamp(26px,3vw,38px);display:flex;flex-direction:column;justify-content:center}
@media(max-width:860px){.agz-landing .pcard .right{border-left:0;border-top:1px solid var(--line)}}
.agz-landing .pcard .rh{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:20px}
.agz-landing .pcard .rh .t{font-size:14px;color:var(--ink-soft);font-weight:600}
.agz-landing .pcard .rh .a{font-size:24px;font-weight:700;letter-spacing:-.03em}
.agz-landing .rows{display:flex;flex-direction:column;gap:16px}
.agz-landing .crow .cl{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:8px}
.agz-landing .crow .cn{font-size:14px;font-weight:500}
.agz-landing .crow .cv{font-size:13px;color:var(--ink-soft);font-weight:600}
.agz-landing .crow .bar{height:7px;border-radius:99px;background:#E7E1D6;overflow:hidden}
.agz-landing .crow .bar i{display:block;height:100%;border-radius:99px;transition:width .7s cubic-bezier(.2,.8,.2,1)}
.agz-landing .mods{display:grid;grid-template-columns:repeat(12,1fr);gap:18px;margin-top:clamp(32px,4vw,52px)}
.agz-landing .mod{background:var(--card);border:1px solid var(--line);border-radius:var(--r-card);padding:26px;position:relative;transition:transform .25s,box-shadow .25s}
.agz-landing .mod:hover{transform:translateY(-4px);box-shadow:var(--sh-card)}
.agz-landing .mod h3{font-size:18px;letter-spacing:-.02em;margin-top:18px;display:flex;align-items:center;gap:9px}
.agz-landing .mod h3 .live{width:7px;height:7px;border-radius:50%;background:#2E8B57;box-shadow:0 0 0 3px rgba(46,139,87,.16)}
.agz-landing .mod p{color:var(--ink-soft);font-size:14px;margin-top:8px;line-height:1.5}
.agz-landing .mod .hero-badge{position:absolute;top:24px;right:24px;font-size:12px;font-weight:600;color:var(--coral)}
.agz-landing .mod-hero{grid-column:span 6}.agz-landing .mod-6{grid-column:span 6}.agz-landing .mod-4{grid-column:span 4}
@media(max-width:800px){.agz-landing .mod-hero,.agz-landing .mod-6{grid-column:span 12}.agz-landing .mod-4{grid-column:span 6}}
@media(max-width:540px){.agz-landing .mod-4{grid-column:span 12}}
.agz-landing .next{margin-top:20px;color:var(--ink-soft);font-size:14.5px}
.agz-landing .next b{color:var(--ink);font-weight:600}
.agz-landing .faq{max-width:740px;margin:clamp(30px,4vw,46px) auto 0}
.agz-landing .faq details{border-bottom:1px solid var(--line)}
.agz-landing .faq summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:16px;padding:22px 4px;font-size:17px;font-weight:600;letter-spacing:-.01em}
.agz-landing .faq summary::-webkit-details-marker{display:none}
.agz-landing .faq .pm{width:20px;height:20px;flex:none;position:relative}
.agz-landing .faq .pm::before,.agz-landing .faq .pm::after{content:"";position:absolute;background:var(--ink-soft);transition:transform .25s}
.agz-landing .faq .pm::before{top:9px;left:3px;right:3px;height:1.7px}
.agz-landing .faq .pm::after{left:9px;top:3px;bottom:3px;width:1.7px}
.agz-landing .faq details[open] .pm::after{transform:scaleY(0)}
.agz-landing .faq details p{padding:0 4px 24px;color:var(--ink-soft);font-size:14.5px;line-height:1.6;max-width:64ch}
.agz-landing .final{position:relative;text-align:center;padding:clamp(70px,10vw,130px) 0;overflow:hidden}
.agz-landing .final .g{position:absolute;inset:0;z-index:0;filter:blur(60px);opacity:.8;pointer-events:none}
.agz-landing .final .g::before{content:"";position:absolute;width:60%;height:80%;left:20%;top:6%;border-radius:50%;background:radial-gradient(circle,rgba(245,150,110,.4),transparent 62%)}
.agz-landing .final .g::after{content:"";position:absolute;width:50%;height:70%;right:14%;top:0;border-radius:50%;background:radial-gradient(circle,rgba(11,103,255,.26),transparent 60%)}
.agz-landing .final .wrap{position:relative;z-index:2}
.agz-landing .final h2{font-size:clamp(38px,7vw,86px);letter-spacing:-.04em;font-weight:600;line-height:1}
.agz-landing .final p{color:var(--ink-soft);font-size:clamp(16px,1.7vw,19px);margin:22px auto 0;max-width:42ch}
.agz-landing .final .cta{display:flex;gap:12px;justify-content:center;margin-top:32px;flex-wrap:wrap}
.agz-landing footer{border-top:1px solid var(--line);background:var(--paper-2);padding:56px 0 36px}
.agz-landing .fg{display:flex;justify-content:space-between;gap:32px;flex-wrap:wrap}
.agz-landing .fb{max-width:300px}
.agz-landing .fb .brand{font-size:22px}
.agz-landing .fb p{color:var(--ink-soft);font-size:13.5px;line-height:1.55;margin-top:12px}
.agz-landing .fcols{display:flex;gap:clamp(28px,5vw,64px);flex-wrap:wrap}
.agz-landing .fcol h4{font-size:13px;color:var(--ink);font-weight:600;margin-bottom:14px;letter-spacing:-.01em}
.agz-landing .fcol a{display:block;font-size:14px;color:var(--ink-soft);margin-bottom:10px;transition:color .2s}
.agz-landing .fcol a:hover{color:var(--blue)}
.agz-landing .fcol button{display:block;font-size:14px;color:var(--ink-soft);margin-bottom:10px;transition:color .2s;background:none;border:0;cursor:pointer;font-family:var(--sans);padding:0;text-align:left}
.agz-landing .fcol button:hover{color:var(--blue)}
.agz-landing .fbot{display:flex;justify-content:space-between;gap:14px;flex-wrap:wrap;margin-top:46px;padding-top:22px;border-top:1px solid var(--line);color:var(--muted);font-size:13px}
@keyframes agzFadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}
@keyframes agzWordIn{from{opacity:.12;transform:translateY(8px)}to{opacity:1;transform:none}}
@keyframes agzCardIn{from{opacity:0;scale:.9}to{opacity:1;scale:1}}
@keyframes agzBgIn{from{opacity:0;transform:scale(1.06)}to{opacity:.9;transform:scale(1)}}
.agz-landing .hero-bg{opacity:.9;animation:agzBgIn 1.5s ease both}
.agz-landing .hero .newbadge{animation:agzFadeUp .7s cubic-bezier(.2,.7,.2,1) both}
.agz-landing .hero h1 .w{display:inline-block;animation:agzWordIn .6s cubic-bezier(.2,.7,.2,1) both}
.agz-landing .hero h1 .w:nth-child(1){animation-delay:.05s}.agz-landing .hero h1 .w:nth-child(2){animation-delay:.12s}
.agz-landing .hero h1 .w:nth-child(3){animation-delay:.19s}.agz-landing .hero h1 .w:nth-child(4){animation-delay:.26s}
.agz-landing .hero h1 .w:nth-child(5){animation-delay:.33s}.agz-landing .hero h1 .w:nth-child(6){animation-delay:.40s}
.agz-landing .hero .sub{animation:agzFadeUp .7s cubic-bezier(.2,.7,.2,1) .44s both}
.agz-landing .hero .cta{animation:agzFadeUp .7s cubic-bezier(.2,.7,.2,1) .54s both}
.agz-landing .hero .note{animation:agzFadeUp .7s cubic-bezier(.2,.7,.2,1) .64s both}
.agz-landing .fcard{animation:agzCardIn .85s cubic-bezier(.16,1,.3,1) both}
.agz-landing .fc-plan{animation-delay:.55s}.agz-landing .fc-metric{animation-delay:.70s}.agz-landing .fc-brain{animation-delay:.85s}.agz-landing .fc-ask{animation-delay:1.0s}
@supports (animation-timeline: view()){
  .agz-landing .rv{opacity:0;animation:agzFadeUp .8s cubic-bezier(.2,.7,.2,1) both;animation-timeline:view();animation-range:entry 0% entry 88%}
}
@media(prefers-reduced-motion:reduce){.agz-landing .fcard{animation-duration:.5s}.agz-landing .hero h1 .w{animation-duration:.4s}}

/* Manifesto section — product showcase video */
.agz-landing .manifesto{display:grid;grid-template-columns:1fr;align-items:center;gap:56px}
.agz-landing .manifesto .wr{margin:0}
.agz-landing .manifesto .small{margin-top:12px}
.agz-landing .showcase{position:relative;justify-self:center;width:100%;max-width:440px;padding:20px;box-sizing:border-box;opacity:0;transform:translateY(14px);transition:opacity .7s cubic-bezier(.2,.7,.2,1),transform .7s cubic-bezier(.2,.7,.2,1)}
.agz-landing .showcase.rv-in{opacity:1;transform:none}
/* The stage now holds a header row, the 3:4 video frame, and a footer row. */
.agz-landing .showcase .stage{position:relative;display:flex;flex-direction:column;border-radius:22px;overflow:hidden;background:#181621;border:1px solid rgba(24,22,33,.08);box-shadow:0 12px 32px rgba(24,22,33,.09),0 2px 6px rgba(24,22,33,.05);transition:transform .28s cubic-bezier(.2,.7,.2,1),box-shadow .28s cubic-bezier(.2,.7,.2,1);z-index:1}
.agz-landing .showcase .sc-header{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;background:#181621;color:#FCFAF3;border-bottom:1px solid rgba(255,255,255,.06);flex:0 0 auto}
.agz-landing .showcase .sc-frame{position:relative;width:100%;aspect-ratio:3/4;background:#0B0A12;overflow:hidden;flex:0 0 auto}
.agz-landing .showcase .sc-frame video{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;object-position:center;display:block;background:#0B0A12}
.agz-landing .showcase .sc-footer{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 14px;background:#FCFAF3;border-top:1px solid rgba(24,22,33,.06);flex:0 0 auto}
.agz-landing .showcase .backplate{position:absolute;inset:34px 4px 4px 34px;border-radius:22px;background:#181621;opacity:.055;z-index:0}
.agz-landing .showcase .backplate.b2{inset:58px -14px -8px 8px;background:linear-gradient(135deg,#F3D9C6 0%,#F0C7B0 100%);opacity:.35;z-index:-1;filter:blur(0.5px)}
.agz-landing .showcase:hover .stage{transform:translateY(-3px);box-shadow:0 22px 48px rgba(24,22,33,.14),0 4px 12px rgba(24,22,33,.06)}
.agz-landing .sc-badge{display:inline-flex;align-items:center;gap:6px;font-size:10px;font-weight:700;letter-spacing:.1em;color:#FCFAF3;text-transform:uppercase;line-height:1}
.agz-landing .sc-badge .n{display:inline-block;width:5px;height:5px;border-radius:999px;background:#E0603A}
.agz-landing .sc-status{display:inline-flex;align-items:center;gap:6px;font-size:10.5px;font-weight:600;color:#FCFAF3;line-height:1;opacity:.85}
.agz-landing .sc-status .dot{width:6px;height:6px;border-radius:999px;background:#4ADE80;box-shadow:0 0 0 0 rgba(74,222,128,.55);animation:agzLivePulse 2s ease-out infinite}
@keyframes agzLivePulse{0%{box-shadow:0 0 0 0 rgba(74,222,128,.55)}70%{box-shadow:0 0 0 8px rgba(74,222,128,0)}100%{box-shadow:0 0 0 0 rgba(74,222,128,0)}}
.agz-landing .sc-caption{flex:1 1 auto;min-width:0;font-size:10.5px;font-weight:600;letter-spacing:.06em;color:#54505B;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.agz-landing .sc-controls{display:inline-flex;align-items:center;gap:6px;flex:0 0 auto}
.agz-landing .sc-btn{display:inline-flex;align-items:center;gap:6px;padding:7px 12px;min-height:34px;border-radius:999px;border:1px solid rgba(24,22,33,.14);background:#FCFAF3;color:#181621;font-size:11.5px;font-weight:600;line-height:1;cursor:pointer;transition:background .18s,border-color .18s,transform .12s;font-family:inherit}
.agz-landing .sc-btn:hover{background:#F3EFE7;border-color:rgba(24,22,33,.24)}
.agz-landing .sc-btn:active{transform:translateY(1px)}
.agz-landing .sc-btn:focus-visible{outline:2px solid #0B67FF;outline-offset:2px}
.agz-landing .sc-btn.is-primary{background:#181621;color:#FCFAF3;border-color:#181621}
.agz-landing .sc-btn.is-primary:hover{background:#000}
.agz-landing .sc-btn.is-icon{padding:7px;min-width:34px;justify-content:center}
.agz-landing .sc-btn svg{width:14px;height:14px;flex:0 0 auto}
@media(min-width: 900px){
  .agz-landing .manifesto{grid-template-columns:1fr 1fr;gap:72px;text-align:left}
  .agz-landing .manifesto .wr,.agz-landing .manifesto .small{text-align:left}
  .agz-landing .showcase{justify-self:end;max-width:420px}
}
@media(max-width: 520px){
  .agz-landing .manifesto{gap:36px}
  .agz-landing .showcase{max-width:340px;padding:14px}
  .agz-landing .showcase .stage{border-radius:18px;box-shadow:0 8px 20px rgba(24,22,33,.08)}
  .agz-landing .showcase .sc-header,.agz-landing .showcase .sc-footer{padding:10px 12px}
  .agz-landing .sc-badge,.agz-landing .sc-status{font-size:9.5px}
  .agz-landing .sc-caption{font-size:9.5px}
  .agz-landing .sc-btn{font-size:11px;padding:8px 10px;min-height:36px}
  .agz-landing .sc-btn.is-icon{min-width:36px}
}
@media(prefers-reduced-motion:reduce){
  .agz-landing .showcase{opacity:1;transform:none;transition:none}
  .agz-landing .showcase:hover .stage{transform:none;box-shadow:0 12px 32px rgba(24,22,33,.09),0 2px 6px rgba(24,22,33,.05)}
  .agz-landing .sc-status .dot{animation:none}
}
`;

const PLANS = [
  { tab: "Pasticceria", biz: "Artisan pastry shop", sub: "Torino · local retail · €600/month", quote: "“Low budget, local demand. Win the neighborhood with organic reels plus geo-fenced Meta. No brand campaigns you can't afford yet.”", opt: "local reach, store visits, repeat rate", amt: "€600", rows: [["Meta Ads · geo 5km", "40% · €240", 40, "var(--coral)"], ["Reels & UGC", "35% · €210", 35, "var(--blue)"], ["Google Business", "15% · €90", 15, "var(--gold)"], ["Email & loyalty", "10% · €60", 10, "var(--peach-2)"]] },
  { tab: "Fashion e-comm", biz: "Fashion e-commerce", sub: "Spain · DTC retail · €3,500/month", quote: "“Volume and margin. Catalog ads do the heavy lifting, TikTok feeds the top of funnel, retention protects your CAC.”", opt: "ROAS, CAC, average order value", amt: "€3,500", rows: [["Meta Advantage+ Shopping", "45% · €1,575", 45, "var(--coral)"], ["Google PMax + Shopping", "30% · €1,050", 30, "var(--blue)"], ["TikTok · creator/UGC", "15% · €525", 15, "var(--gold)"], ["Email & retention", "10% · €350", 10, "var(--peach-2)"]] },
  { tab: "B2B SaaS", biz: "B2B SaaS", sub: "Germany · B2B software · €8,000/month", quote: "“Long cycle, high ACV. Educate the buying committee, capture intent on Google, nurture with content. Brand isn't leads. We fund both, on purpose.”", opt: "SQLs, pipeline value, CAC payback", amt: "€8,000", rows: [["LinkedIn Ads · ABM", "35% · €2,800", 35, "var(--coral)"], ["Content & SEO", "25% · €2,000", 25, "var(--blue)"], ["Google Search · intent", "20% · €1,600", 20, "var(--gold)"], ["Webinars & events", "12% · €960", 12, "var(--peach-2)"], ["Retargeting", "8% · €640", 8, "var(--muted)"]] },
  { tab: "Online PT", biz: "Online personal trainer", sub: "Online · solo creator · €300/month", quote: "“Tiny budget: content is the channel. Paid only amplifies your best organic and captures leads to a free plan. Every euro chases a conversation.”", opt: "leads, DM conversations, free-plan sign-ups", amt: "€300", rows: [["Organic Reels/Shorts", "primary · time", 100, "var(--blue)"], ["Meta Ads · lead magnet", "55% · €165", 55, "var(--coral)"], ["Email nurture", "25% · €75", 25, "var(--gold)"], ["Community & UGC", "20% · €60", 20, "var(--peach-2)"]] },
  { tab: "Dental clinic", biz: "Dental clinic", sub: "Milano · local service · €2,000/month", quote: "“People search when they need a dentist. Own high-intent local search and reviews; Meta warms the area. We optimize for booked appointments, not likes.”", opt: "booked appointments, cost per booking, review score", amt: "€2,000", rows: [["Google Search + Local", "40% · €800", 40, "var(--coral)"], ["Reviews & Local SEO", "20% · €400", 20, "var(--blue)"], ["Meta Ads · geo offers", "25% · €500", 25, "var(--gold)"], ["Booking landing", "15% · €300", 15, "var(--peach-2)"]] },
];

const ArrowSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

const Bar = ({ w, color }) => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const id = requestAnimationFrame(() => setWidth(Math.min(100, w)));
    return () => cancelAnimationFrame(id);
  }, [w]);
  return <div className="bar"><i style={{ width: `${width}%`, background: color }} /></div>;
};

// Explainer video for the Agenzee application. Vertical 3:4 frame preserved
// end-to-end (object-fit:contain, no crop). Header holds identity chips,
// footer holds a caption + Play/Pause and Watch with sound controls.
const VideoShowcase = () => {
  const wrapRef = useRef(null);
  const videoRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [soundOn, setSoundOn] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReducedMotion(mq.matches);
    onChange();
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el || typeof IntersectionObserver !== "function") { setVisible(true); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          setVisible(true);
          const v = videoRef.current;
          // Do NOT auto-start playback when the user prefers reduced motion.
          if (v && v.paused && !reducedMotion) {
            const p = v.play();
            if (p && typeof p.catch === "function") p.catch(() => { /* autoplay blocked — user can hit Play */ });
          }
          io.disconnect();
        }
      });
    }, { rootMargin: "120px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [reducedMotion]);

  // Keep the React state in sync with actual media events.
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    v.addEventListener("play", onPlay);
    v.addEventListener("pause", onPause);
    return () => { v.removeEventListener("play", onPlay); v.removeEventListener("pause", onPause); };
  }, []);

  const togglePlay = () => {
    const v = videoRef.current; if (!v) return;
    if (v.paused) { const p = v.play(); if (p && typeof p.catch === "function") p.catch(() => {}); }
    else { v.pause(); }
  };

  const toggleSound = () => {
    const v = videoRef.current; if (!v) return;
    if (soundOn) {
      v.muted = true;
      setSoundOn(false);
    } else {
      // User gesture: restart from the beginning with sound.
      v.muted = false;
      v.volume = 0.85;
      try { v.currentTime = 0; } catch (_) { /* some browsers restrict this until metadata is loaded */ }
      const p = v.play(); if (p && typeof p.catch === "function") p.catch(() => {});
      setSoundOn(true);
    }
  };

  return (
    <div
      ref={wrapRef}
      className={`showcase${visible ? " rv-in" : ""}`}
      data-testid="landing-video-showcase"
    >
      <span className="backplate b2" aria-hidden="true" />
      <span className="backplate" aria-hidden="true" />
      <div className="stage">
        <div className="sc-header">
          <span className="sc-badge" data-testid="showcase-badge"><span className="n" />Agenzee in action</span>
          <span className="sc-status" data-testid="showcase-status">
            <span className="dot" aria-hidden="true" /> Live workflow
          </span>
        </div>
        <div className="sc-frame">
          <video
            ref={videoRef}
            src="/video/agenzee-demo.mp4"
            poster="/video/agenzee-demo-poster.jpg"
            autoPlay={!reducedMotion}
            muted
            loop
            playsInline
            preload="metadata"
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
            aria-label="Agenzee application explainer video"
            data-testid="showcase-video"
          />
        </div>
        <div className="sc-footer">
          <span className="sc-caption" data-testid="showcase-caption">Strategy. Content. Execution.</span>
          <div className="sc-controls">
            <button
              type="button"
              className="sc-btn is-icon"
              onClick={togglePlay}
              aria-label={playing ? "Pause explainer video" : "Play explainer video"}
              aria-pressed={playing}
              data-testid="showcase-play-btn"
            >
              {playing ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a.5.5 0 0 0 .77.42l10.5-6.5a.5.5 0 0 0 0-.85L8.77 5.08A.5.5 0 0 0 8 5.5Z" /></svg>
              )}
            </button>
            <button
              type="button"
              className={`sc-btn${soundOn ? "" : " is-primary"}`}
              onClick={toggleSound}
              aria-label={soundOn ? "Mute explainer video" : "Watch explainer video with sound"}
              aria-pressed={soundOn}
              data-testid="showcase-sound-btn"
            >
              {soundOn ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z" /><path d="M16 9l6 6M22 9l-6 6" /></svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z" /><path d="M15.5 8.5a5 5 0 0 1 0 7" /><path d="M18.5 5.5a9 9 0 0 1 0 13" /></svg>
              )}
              <span>{soundOn ? "Mute" : "Watch with sound"}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function Landing() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [tab, setTab] = useState(0);
  const [stuck, setStuck] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const floatsRef = useRef(null);

  const go = () => navigate(user ? "/app" : "/auth?mode=register");
  const p = PLANS[tab];

  const handleMobileNav = (hash) => {
    setMenuOpen(false);
    // Let default anchor scroll happen after menu closes
    setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const floats = floatsRef.current ? [...floatsRef.current.querySelectorAll(".fcard")] : [];
    floats.forEach((f, i) => { f._phase = i * 1.7; f._amp = 6 + (i % 2) * 5; f._spd = 0.00055 + (i % 3) * 0.00013; });
    let tx = 0, ty = 0, cx = 0, cy = 0, rafId = null;
    const onMove = (e) => { tx = e.clientX / window.innerWidth - 0.5; ty = e.clientY / window.innerHeight - 0.5; };
    window.addEventListener("mousemove", onMove, { passive: true });
    const raf = (t) => {
      cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
      floats.forEach((f) => {
        const d = +f.dataset.depth || 20;
        const fy = Math.sin(t * f._spd + f._phase) * f._amp;
        f.style.translate = (cx * d).toFixed(1) + "px " + (cy * d + fy).toFixed(1) + "px";
      });
      rafId = requestAnimationFrame(raf);
    };
    if (!reduce && window.innerWidth > 820) rafId = requestAnimationFrame(raf);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mousemove", onMove);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className="agz-landing" data-testid="landing-page">
      <style>{CSS}</style>
      <header className={`nav${stuck ? " stuck" : ""}`} id="nav">
        <div className="wrap">
          <a href="#" className="brand" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}><img src="/branding/agenzee-logo.png" alt="Agenzee" /></a>
          <nav className="nav-mid">
            <a href="#how">How it works</a><a href="#proof">The proof</a><a href="#modules">Modules</a><a href="#pricing">Pricing</a><a href="#faq">FAQ</a>
          </nav>
          <div className="nav-right">
            <Link className="login" to="/auth" data-testid="nav-login-link">Log in</Link>
            <button className="btn btn--primary" onClick={go} data-testid="nav-get-plan-btn">Get your plan</button>
            <button
              className="nav-burger"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              data-testid="nav-burger-btn"
            >
              {menuOpen ? (
                <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" /></svg>
              ) : (
                <svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
              )}
            </button>
          </div>
        </div>
        <nav className={`nav-mobile${menuOpen ? " open" : ""}`} data-testid="nav-mobile-menu">
          <a href="#how" onClick={(e) => { e.preventDefault(); handleMobileNav("#how"); }} data-testid="nav-mobile-how">How it works</a>
          <a href="#proof" onClick={(e) => { e.preventDefault(); handleMobileNav("#proof"); }} data-testid="nav-mobile-proof">The proof</a>
          <a href="#modules" onClick={(e) => { e.preventDefault(); handleMobileNav("#modules"); }} data-testid="nav-mobile-modules">Modules</a>
          <a href="#pricing" onClick={(e) => { e.preventDefault(); handleMobileNav("#pricing"); }} data-testid="nav-mobile-pricing">Pricing</a>
          <a href="#faq" onClick={(e) => { e.preventDefault(); handleMobileNav("#faq"); }} data-testid="nav-mobile-faq">FAQ</a>
          <Link to="/auth" className="login-m" onClick={() => setMenuOpen(false)} data-testid="nav-mobile-login">Log in</Link>
        </nav>
      </header>

      <section className="hero">
        <div className="hero-bg"><span></span></div>
        <div className="floats" id="floats" ref={floatsRef}>
          <div className="fcard fc-plan" data-depth="18">
            <div className="ft">Media plan · €600/mo</div>
            <div className="donut"><div className="ring"></div><div className="c"><b>Balanced</b><span>4 channels</span></div></div>
            <div className="leg">
              <div className="lr"><i style={{ background: "var(--coral)" }}></i>Meta Ads<b>€240</b></div>
              <div className="lr"><i style={{ background: "var(--blue)" }}></i>Reels &amp; UGC<b>€210</b></div>
              <div className="lr"><i style={{ background: "var(--gold)" }}></i>Google<b>€90</b></div>
            </div>
          </div>
          <div className="fcard fc-metric" data-depth="28">
            <div className="ft">Booked appointments</div>
            <div className="metric"><b className="big">+18%</b><span className="up">▲ vs last month</span>
              <svg className="spark" viewBox="0 0 120 34" preserveAspectRatio="none"><path d="M2 28 L20 24 L38 26 L56 16 L74 18 L92 9 L118 4" fill="none" stroke="#0B67FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </div>
          </div>
          <div className="fcard fc-brain" data-depth="22">
            <div className="ft">Brand Brain</div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div className="i3d i3d--peach"><svg viewBox="0 0 24 24"><path d="M12 4a4 4 0 0 0-4 4 3 3 0 0 0-1 5.8V16a3 3 0 0 0 5 2 3 3 0 0 0 5-2v-2.2A3 3 0 0 0 16 8a4 4 0 0 0-4-4z" /></svg></div>
              <div style={{ fontSize: 13, lineHeight: 1.4 }}><b style={{ fontWeight: 600 }}>Voice: confident, warm</b><br /><span style={{ color: "var(--muted)" }}>Extracted from your site</span></div>
            </div>
          </div>
          <div className="fcard fc-ask" data-depth="34">
            <div className="ft">Ask Agenzee</div>
            <div className="ask"><input value="Why Meta over Google for me?" readOnly /><span className="send"><svg viewBox="0 0 24 24"><path d="M7 17L17 7M17 7H9M17 7v8" /></svg></span></div>
          </div>
        </div>
        <div className="wrap">
          <a className="newbadge" href="#modules"><span className="n">New</span> Carousel Maker is live <span className="chev">›</span></a>
          <h1><span className="w">The</span> <span className="w">marketing</span> <span className="w">direction</span> <span className="w">your</span> <span className="w">budget</span> <span className="w">deserves</span></h1>
          <p className="sub">Finally, any business can get a real media plan grounded in its numbers. Agenzee decides where your money goes, and tells you why.</p>
          <div className="cta">
            <button className="btn btn--primary btn--lg" onClick={go} data-testid="hero-get-plan-btn">Get your media plan <ArrowSvg /></button>
            <a className="btn btn--ghost btn--lg" href="#proof" data-testid="hero-see-plan-link">See a live plan</a>
          </div>
          <p className="note">Built for every business, from a €300 personal trainer to an €8,000 SaaS.</p>
        </div>
      </section>

      <section className="wrap">
        <div className="manifesto rv">
          <div>
            <p className="wr">Not an assistant that <span className="faint">suggests</span>.<br />A director that <span className="b">decides</span>.</p>
            <p className="small">And tells you exactly why, the way a real CMO would.</p>
          </div>
          <VideoShowcase />
        </div>
      </section>

      <section className="sec" id="how">
        <div className="wrap">
          <div className="sec-head rv"><div className="k">How it works</div><h2 className="wr">From your URL to a plan that's actually produced.</h2><p>No blank page, no generic advice. Three steps from your website to a marketing direction with the assets to run it.</p></div>
          <div className="steps">
            <div className="step rv"><div className="i3d i3d--blue"><svg viewBox="0 0 24 24"><path d="M9 15l6-6" /><path d="M11 7l1-1a4 4 0 0 1 6 6l-1 1" /><path d="M13 17l-1 1a4 4 0 0 1-6-6l1-1" /></svg></div><div className="st">Step 01</div><h3>Paste your URL</h3><p>We read your site and build your Brand Brain: voice, offer, audience, colors. Your first output in minutes, not weeks.</p></div>
            <div className="step rv"><div className="i3d i3d--coral"><svg viewBox="0 0 24 24"><path d="M4 4v16h16" /><path d="M7 14l3-4 3 3 5-7" /></svg></div><div className="st">Step 02</div><h3>Get your media plan</h3><p>A real budget split by channel, for your sector and your numbers. The engine decides the direction and shows the reasoning.</p></div>
            <div className="step rv"><div className="i3d i3d--gold"><svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M4 9h16M9 20V9" /></svg></div><div className="st">Step 03</div><h3>Produce it, for real</h3><p>Scripts, editorial plans, carousels, ad creative, landing pages, generated on-brand and ready to publish.</p></div>
          </div>
        </div>
      </section>

      <section className="sec" id="proof">
        <div className="wrap">
          <div className="sec-head center rv"><div className="k">The proof</div><h2 className="wr">Same engine. Five businesses. Five plans that share nothing.</h2><p>Grounded in real numbers means the plan changes with the business. If the dentist's plan looked like the SaaS's, we'd have built it wrong.</p></div>
          <div className="proof rv">
            <div className="ptabs" id="ptabs">
              {PLANS.map((pl, i) => (
                <button key={pl.tab} className={`ptab${i === tab ? " on" : ""}`} onClick={() => setTab(i)} data-testid={`proof-tab-${i}`}>{pl.tab}</button>
              ))}
            </div>
            <div className="pcard">
              <div className="left"><div className="biz" data-testid="proof-biz">{p.biz}</div><div className="sub">{p.sub}</div><div className="quote">{p.quote}</div><div className="opt"><b>Optimized for</b> {p.opt}.</div></div>
              <div className="right"><div className="rh"><span className="t">Monthly media plan</span><span className="a">{p.amt}</span></div>
                <div className="rows" key={tab}>
                  {p.rows.map((r) => (
                    <div className="crow" key={r[0]}>
                      <div className="cl"><span className="cn">{r[0]}</span><span className="cv">{r[1]}</span></div>
                      <Bar w={r[2]} color={r[3]} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec" id="modules">
        <div className="wrap">
          <div className="sec-head rv"><div className="k">Inside Agenzee</div><h2 className="wr">Everything the plan needs. In one place.</h2><p>From the CEO-level strategy down to the carousel that ships today. One workspace, one direction.</p></div>
          <div className="mods">
            <div className="mod mod-hero rv"><span className="hero-badge">Hero module</span><div className="i3d i3d--coral"><svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M3 10h18" /><path d="M8 15h6" /></svg></div><h3>Carousel Maker <span className="live" title="Live"></span></h3><p>Art-directed, on-brand carousels generated end to end. The studio our users open first. Format toggles, live preview, PNG/PDF export.</p></div>
            <div className="mod mod-6 rv"><div className="i3d i3d--blue"><svg viewBox="0 0 24 24"><path d="M4 4v16h16" /><path d="M7 15l3-3 3 2 4-6" /></svg></div><h3>CEO Dashboard · Strategy <span className="live" title="Live"></span></h3><p>Your marketing direction as a living plan: budget, channels, action plan. The decisions, with the reasoning behind each one.</p></div>
            <div className="mod mod-4 rv"><div className="i3d i3d--gold"><svg viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h10" /></svg></div><h3>Organic Studio <span className="live" title="Live"></span></h3><p>Scripts, editorial plan and calendar. A content engine that stays on message.</p></div>
            <div className="mod mod-4 rv"><div className="i3d i3d--ink"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></svg></div><h3>Creative Studio <span className="live" title="Live"></span></h3><p>Ad creative that looks made by a team, not a template. On brand, every time.</p></div>
            <div className="mod mod-4 rv"><div className="i3d i3d--peach"><svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="7" rx="1.5" /><rect x="4" y="14" width="10" height="6" rx="1.5" /></svg></div><h3>Landing Pages <span className="live" title="Live"></span></h3><p>Conversion-first pages generated from your plan: copy, structure, design.</p></div>
          </div>
          <p className="next rv"><b>Coming next:</b> Results analytics and the Ads Publisher. We ship what works. No vaporware.</p>
        </div>
      </section>

      <section className="sec" id="pricing">
        <div className="wrap">
          <div className="sec-head center rv"><div className="k">Pricing</div><h2 className="wr">Plans that fit your budget.</h2></div>
          <div className="rv" id="pricing-embed">
            <PricingPlans
              onSelect={go}
              ctaLabel={(p) => (p.id === "starter" ? "Unlock for free" : "Try 7 days free")}
            />
          </div>
        </div>
      </section>

      <section className="final" id="cta">
        <div className="g"></div>
        <div className="wrap">
          <h2 className="rv">the agency, distilled.</h2>
          <p className="rv">Give your budget the direction it deserves. Paste your URL and see your first plan.</p>
          <div className="cta rv">
            <button className="btn btn--primary btn--lg" onClick={go} data-testid="final-get-plan-btn">Get your media plan <ArrowSvg /></button>
            <a className="btn btn--ghost btn--lg" href="#how">How it works</a>
          </div>
        </div>
      </section>

      <section className="sec" id="faq">
        <div className="wrap">
          <div className="sec-head center rv"><div className="k">FAQ</div><h2 className="wr">Questions, answered.</h2></div>
          <div className="faq rv">
            <details open><summary>What exactly is Agenzee?<span className="pm"></span></summary><p>An AI CMO for small business. It builds a real media plan on your actual budget and sector, explains the reasoning, then produces the assets to run it: scripts, carousels, ad creative and landing pages.</p></details>
            <details><summary>How is this different from an AI assistant?<span className="pm"></span></summary><p>An assistant suggests ideas and leaves the decisions to you. Agenzee decides the direction (where the money goes and why) the way a marketing director would, then hands you the work already done.</p></details>
            <details><summary>What budgets does it work with?<span className="pm"></span></summary><p>Any. From around €300 a month to five figures. The plan is grounded in your numbers, so it changes with your budget and sector. A €600 pastry shop and an €8,000 SaaS get genuinely different plans.</p></details>
            <details><summary>Do I need marketing experience?<span className="pm"></span></summary><p>No. Paste your website URL and Agenzee extracts your Brand Brain (voice, offer, audience) then proposes the plan. You stay in control and can refine anything.</p></details>
            <details><summary>Is everything available today?<span className="pm"></span></summary><p>The strategy engine, Brand Brain, Carousel Maker, Creative Studio, Organic Studio and Landing Pages are live. Results analytics and the Ads Publisher are on the roadmap. We ship what works rather than promise vaporware.</p></details>
          </div>
        </div>
      </section>

      <footer>
        <div className="wrap">
          <div className="fg">
            <div className="fb"><a href="#" className="brand" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}><img src="/branding/agenzee-logo.png" alt="Agenzee" /></a><p>The AI CMO for small business. A real media plan, grounded in your numbers. Decided, explained, produced.</p></div>
            <div className="fcols">
              <div className="fcol"><h4>Product</h4><a href="#how">How it works</a><a href="#proof">The proof</a><a href="#modules">Modules</a><a href="#faq">FAQ</a></div>
              <div className="fcol"><h4>Company</h4><Link to="/about" data-testid="footer-about-link">About</Link><Link to="/manifesto" data-testid="footer-manifesto-link">Manifesto</Link><Link to="/contact" data-testid="footer-contact-link">Contact</Link></div>
              <div className="fcol"><h4>Legal</h4><Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link><Link to="/termini" data-testid="footer-terms-link">Terms</Link></div>
            </div>
          </div>
          <div className="fbot"><span>© 2026 Agenzee, the agency distilled</span><span>Built on Emergent</span></div>
        </div>
      </footer>
    </div>
  );
}
